import { flattenDeep } from "./arrayHelpers.mjs";
import { flattenObject } from "./objectHelpers.mjs";
export const flattenFieldSet = (fieldSet) => {
  return fieldSet.map(flattenObject);
};
export const getFlattenedMaterialComposition = (materialCompositions) => {
  return materialCompositions.map((materialComposition) => ({
    ...flattenDeep(flattenFieldSet(materialComposition.fieldSet))[0],
    values: flattenDeep(
      materialComposition.groupSet.map((g) => flattenFieldSet(g.fieldSet))
    )
  }));
};
export const getFlattenedAdvancedAttribute = (attributeGroup) => {
  return attributeGroup.map((groupItem) => ({
    ...flattenDeep(flattenFieldSet(groupItem.fieldSet))[0],
    values: flattenDeep(
      groupItem.groupSet.map((g) => flattenFieldSet(g.fieldSet))
    )
  }));
};
export const getFlattenedVariantCrosssellings = (variantCrosssellings) => {
  return getFlattenedAdvancedAttribute(variantCrosssellings);
};
